export default "__VITE_ASSET__fd001ef5__"